// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"b016a99a","796":"86d41c43"}[chunkId] + ".chunk.js";
};